// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"4904":"b3528480","9258":"bcb5ee45"}[chunkId] || chunkId) + "." + {"3402":"25e7f1b38ba2be67","4904":"e9c51fd738d24508","6681":"6dd466eb48845f3c","9258":"8db7bd436bb5b0fa"}[chunkId] + ".js";
};